import React from 'react';
import { useNavigate } from 'react-router-dom';
import HrnbContainer, { HrnbRow, HrnbCol } from '../components/controls/HrnbContainer';
import HrnbCard from '../components/controls/HrnbCard';
import HrnbButton from '../components/controls/HrnbButton';
import { HomeIcon, BackIcon } from '../icons';
import '../css/pages/NotFoundPage.css';

/**
 * Страница 404 - страница не найдена
 */
export default function NotFoundPage() {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <HrnbContainer className="not-found-page">
            <HrnbRow>
                <HrnbCol xs={12}>
                    <HrnbCard className="not-found-card">
                        <div className="not-found-content">
                            <div className="not-found-icon">🔍</div>
                            <h1 className="not-found-title">404</h1>
                            <h2 className="not-found-subtitle">Страница не найдена</h2>
                            <p className="not-found-description">
                                Извините, но страница, которую вы ищете, не существует или была перемещена.
                            </p>
                            <div className="not-found-actions">
                                <HrnbButton variant="primary" onClick={handleGoHome} className="not-found-btn" icon={<HomeIcon />}>
                                    На главную
                                </HrnbButton>
                                <HrnbButton variant="secondary" onClick={handleGoBack} className="not-found-btn" icon={<BackIcon />}>
                                    Назад
                                </HrnbButton>
                            </div>
                        </div>
                    </HrnbCard>
                </HrnbCol>
            </HrnbRow>
        </HrnbContainer>
    );
}
